import { render, staticRenderFns } from "./BorderNavButton.vue?vue&type=template&id=4ff11a96&scoped=true&"
import script from "./BorderNavButton.vue?vue&type=script&lang=ts&"
export * from "./BorderNavButton.vue?vue&type=script&lang=ts&"
import style0 from "./BorderNavButton.vue?vue&type=style&index=0&id=4ff11a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff11a96",
  null
  
)

export default component.exports